// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"a0c43f1d","453":"ed3810f9"}[chunkId] + ".chunk.js";
};